<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :manual-check-group="manualCheckGroup"
            @form-submitted="submitData"
        />
    </DCard>
</template>
<script>

import Form from '~@/Components/Settings/OrderSettings/ManualChecks/Groups/Form'
export default {
    name: 'ManualCheckGroupEdit',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        manualCheckGroup: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('settings.order-manual-check-group-settings.update', this.manualCheckGroup.id))
        }
    }
}
</script>
